<template>
  <div class="entry-view-holder blog">
    <loader
      v-if="item == null || loading"
      :show="item == null"
      :width="40"
      :height="40"
    />

    <top-bar
      v-if="item != null"
      :title="id == 'new' ? 'Inserimento Articoli' : 'Modifica Articoli'"
      :preview="item.contents[lang].permalink + '?preview=1'"
      :action="`Salva`"
      :actionIsValid="isValid"
      :loading="loading || item == null"
      @lang="
        (l) => {
          lang = l;
          $v.$touch();
        }
      "
      @onAction="save"
    />
    <div v-if="item && item.draft > 0">
      <div class="alert alert-info alert-with-icon">
        <button type="button" aria-hidden="true" class="close">×</button>
        <span data-notify="icon" class="ti-bell"></span>
        <span data-notify="message">Scheda BOZZA di Revisione</span>
      </div>
    </div>
    <form :class="['form', 'row']" novalidate v-if="item != null">
      <div class="col-md-9">
        <card title="Informazioni blog" :collapsed="false">
          <content>
            <textbox
              title="Titolo articolo"
              :v="$v.item.contents[lang].title"
              v-model="item.contents[lang].title"
            />
            <textbox
              title="Slug"
              :v="$v.item.contents[lang].slug"
              v-model="item.contents[lang].slug"
            />
            <textbox
              title="Sottotitolo articolo"
              :v="$v.item.contents[lang].subtitle"
              v-model="item.contents[lang].subtitle"
            />
            <div class="form-group">
              <label>Descrizione</label>
              <rich-editor
                :v="$v.item.contents[lang].description"
                v-model="item.contents[lang].description"
              />
            </div>
            <div class="form-group">
              <label>Tags</label>
              <tag-manager
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].tags"
                :canAddTags="canAddTags"
                :language="lang"
              />
            </div>
          </content>
        </card>
        <card title="Informazioni SEO" :collapsed="false">
          <content>
            <fieldset>
              <h5>SEO</h5>
              <textbox
                title="Keywords"
                :v="$v.item.contents[lang].google.keywords"
                v-model="item.contents[lang].google.keywords"
              />
              <textbox
                title="Title"
                :v="$v.item.contents[lang].google.title"
                v-model="item.contents[lang].google.title"
              />
              <a-textarea
                title="Meta Descrizione"
                :maxLength="170"
                :v="$v.item.contents[lang].google.description"
                v-model="item.contents[lang].google.description"
              />
            </fieldset>
            <fieldset>
              <h5>Social</h5>
              <textbox
                title="Title"
                :v="$v.item.contents[lang].social.title"
                v-model="item.contents[lang].social.title"
              />
              <a-textarea
                title="Meta Descrizione"
                :v="$v.item.contents[lang].social.description"
                v-model="item.contents[lang].social.description"
              />
            </fieldset>
          </content>
        </card>
        <card title="Immagini" :collapse="false">
          <attachments-box v-model="item.attachments"></attachments-box>
        </card>
      </div>
      <!-- Sidebar DX -->
      <div class="col-md-3">
        <card title="Impostazioni">
        <statuses-box ref="sbox"
            v-model="item.contents[lang].status"
            title="false"
            :lang="lang"
            :entity="item.id"
            :statuses="item.nextStatuses ? item.nextStatuses[lang] || null : null"
          ></statuses-box>

          <author-box v-model="item.contents[lang].author" />
          <date-picker v-model="item.contents[lang].pub_date" />
        </card>
        <card title="Interessi" :collapse="false">
          <fieldset>
            <category-combo
              :mainCategory="5"
              v-model="item.theme"
            ></category-combo>
          </fieldset>
        </card>
        <card title="Location" :collapse="false">
          <fieldset>
            <city-combo-multiselect
              v-model="item.comune"
            ></city-combo-multiselect>
          </fieldset>
        </card>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

import ATextarea from "@/components/altrama/form/ATextarea.vue";
import Textbox from "@/components/altrama/form/Textbox.vue";
import TopBar from "@/components/altrama/TopBar.vue";
import Card from "@/components/Cards/Card.vue";
import Content from "@/layout/Content.vue";
import RichEditor from "@/components/altrama/RichEditor.vue";
import TagManager from "@/components/altrama/TagManager";
import StatusesBox from "@/components/altrama/StatusesBox.vue";
import AuthorBox from "@/components/altrama/AuthorBox.vue";
import DatePicker from "@/components/altrama/DatePicker.vue";
import CityComboMultiselect from "@/components/altrama/CityComboMultiselect.vue";
import CategoryCombo from "@/components/altrama/CategoryCombo.vue";
import AttachmentsBox from "@/components/altrama/AttachmentsBox.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    TopBar,
    Card,
    Content,
    Textbox,
    ATextarea,
    RichEditor,
    TagManager,
    StatusesBox,
    AuthorBox,
    DatePicker,
    CityComboMultiselect,
    CategoryCombo,
    AttachmentsBox,
  },

  props: ["id"],
  mixins: [validationMixin],

  validations() {
    if (
      !!this.item &&
      !!this.item.contents[this.lang] &&
      this.item.contents[this.lang].status == 1
    ) {
      return {
        item: {
          contents: this.$contentTemplate({
            statuses: {},
            title: { required },
            description: { required },
            excerpt: { required },
            google: {
              description: { required },
              keywords: { required },
              title: { required },
            },
            slug: { required },
            social: { description: { required }, title: { required } },
          }),
          referente: {
            it: "",
            en: "",
          },
        },
      };
    }
    return {
      item: {
        contents: this.$contentTemplate({
          title: { required },
          description: "",
          excerpt: "",
          google: { description: "", keywords: "", title: "" },
          slug: "",
          social: { description: "", title: "" },
          subtitle: "",
          statuses: {},
        }),
        referente: {
          it: "",
          en: "",
        },
        contacts: {
          it: [],
          en: [],
        },
      },
    };
  },

  data() {
    return {
      loading: true,
      needSave: false,
      lang: "it",
      item: null,
    };
  },

  computed: {
    isValid() {
      if (!this.item.canSave) {
        if (this.item.contents[this.lang].status == 1) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },

    template() {
      const userId = Number(this.$api.user.current().id);
      return {
        id: "new",
        contents: this.$contentTemplate({
          description: "",
          excerpt: "",
          google: { description: "", keywords: "", title: "" },
          slug: "",
          social: { description: "", title: "" },
          subtitle: "",
          title: "",
          tags: [],
          author: userId,
          status: 2,
          statuses: {},
          permalink: "",
          pub_date: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        }),
        locations: [],
        category: [],
        attachments: [],
        target: [],
        theme: [],
        destinazione: [],
        portal: [
          {
            id: 1,
            active: false,
          },
          {
            id: 2,
            active: false,
          },
          {
            id: 3,
            active: false,
          },
        ],
        comune: [],
        canSave: false,
        created_at: "",
        updated_at: "",
      };
    },
  },

  methods: {
    loadData() {
      let self = this;
      self.item = null;

      if (this.id === "new") {
        self.item = JSON.parse(JSON.stringify(this.template));
        self.needSave = false;
        self.loading = false;
        return;
      }
      self.loading = true;

      axios({
        method: "GET",
        url: `${self.$url}blog/${self.id}`,
        headers: this.$config.axiosHeaders(),
      })
        .then((response) => {
          self.item = _.merge(
            JSON.parse(JSON.stringify(self.template)),
            response.data.data
          );
          self.loading = false;
        })

        .catch((error) => {
          self.loading = false;
          console.log(error);
        });
    },

    save() {
      console.log("Dalla funzione save");
      this.$v.$touch();
      if (!this.$v.item.contents[this.lang].$anyError) {
        let self = this;
        let url = `${self.$url}blog/${self.id}`;
        let method = "put";

        if (this.item.id == "new") {
          method = "post";
          url = `${self.$url}blog`;
        }

        this.item.lang = this.lang;
        this.loading = true;

        axios({
          method: method,
          url: url,
          headers: this.$config.axiosHeaders(),
          data: this.item,
        })
          .then(function (response) {
            self.loading = false;
            self.$notifyVue(
              "top",
              "center",
              response.data.status,
              response.data.data.message,
              "ti-check"
            );
            if (response.data.data.id !== self.item.id) {
              self.item.id = response.data.data.id;
              self.$router.push({ params: { id: self.item.id } });
            }
          })
          .catch(function (error) {
            self.loading = false;
            self.hasErrors = true;
           self.$processError(error);
        });
      }
      this.needSave = false;
      console.log("Save: ", JSON.stringify(this.item));
    },
  },

mounted: async function () {
    this.canAddTags = await this.$api.user.can('view-tag');
    this.loadData();
  },
  watch: {
    id: {
      handler(val, oldVal) {
        this.loadData();
      },
      deep: true,
    },
  }
};
</script>

<style scoped>
</style>
